import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core'
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete'
import { compareTwoStrings } from 'string-similarity'
import { PlayerService } from '../../../core/services/player.service'
import { Player } from '../../../core/models/player.model'
import { AtletiPlayer } from '../../../core/models/atleti-player.model'
import { MatSelectModule } from '@angular/material/select'
import { SnackbarService } from '../../../core/services/snackbar.service'
import { ButtonModule } from '../../../shared/modules/button.module'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'search-player-dialog',
    templateUrl: 'search-player.component.html',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ButtonModule,
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        CommonModule,
        MatDialogClose,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatSelectModule
    ],
    styleUrl: './search-player.component.css'
})
  export class SearchPlayerDialog {
    @ViewChild('playerInput') playerInput!: ElementRef<HTMLInputElement>
    homegrownOptions:string[] = ['Sí', 'No']
    players:Player[] = []
    filteredPlayers:Player[] = []
    private debounceTimeout: any

    constructor(
        public service: PlayerService, 
        public dialogRef: MatDialogRef<SearchPlayerDialog>,
        public snackbarService: SnackbarService
    ){}

    filter(inputElement: HTMLInputElement) {
        clearTimeout(this.debounceTimeout)
        const inputValue = inputElement.value.toLowerCase()
        this.debounceTimeout = setTimeout(() => {
            if(inputValue.length > 1)
            this.service.fetchPlayers(inputValue, '').subscribe(players=>{
                this.filteredPlayers = players as Player[]
            })
        }, 300)
    }

    handleEnter(event: Event, autoComplete: MatAutocomplete | null) {
        event.preventDefault()

        let selectedOption: any = null

        // Intenta seleccionar la opción activa primero
        if (autoComplete && autoComplete.options) {
            const options = autoComplete.options.toArray()
            selectedOption = options.find(option => option.active)?.value

            // Si ninguna está activa, coge la primera
            if (!selectedOption && options.length > 0) {
            selectedOption = options[0].value
            }
        }

        // Fallback por si falla lo anterior
        if (!selectedOption && this.filteredPlayers.length > 0) {
            selectedOption = this.filteredPlayers[0]
        }

        if (selectedOption) {
            this.service.playerAtletiForm.get('player')?.setValue(selectedOption)
        }
        this.onSubmit()
    }

    onPlayerSelected(input: HTMLInputElement) {
        setTimeout(() => input.blur(), 100)
    }

    onSubmit(){
        this.service.postPlayerToTeam('66969b1f21b3dbe997311819')
        .subscribe(response => {
            var r = response as AtletiPlayer
            this.snackbarService.showSnackbar('Successfully added: ' + r.player.name)
            this.dialogRef.close()
            this.playerInput.nativeElement.value = ''
            this.service.playerAtletiForm.get('player')?.setValue(null)
        })
    }

    displayFn(value: Player) {
        return value ? value.name : ""
    }
}